/**
 * Native Google review filtering and progressive reveal.
 * Initializes [data-google-reviews] idempotently and supports Shopify section reloads.
 */
(() => {
  const initGoogleReviews = (section) => {
    if (!section || section.dataset.googleReviewsInitialized === 'true') return;

    const cards = Array.from(section.querySelectorAll('[data-review-card]'));
    const filters = Array.from(section.querySelectorAll('[data-review-filter]'));
    const moreButton = section.querySelector('[data-review-more]');
    const status = section.querySelector('[data-review-status]');

    if (!cards.length || !filters.length) return;

    section.dataset.googleReviewsInitialized = 'true';

    const initialCount = Math.max(1, Number(section.dataset.initialCount) || 9);
    const loadCount = Math.max(1, Number(section.dataset.loadCount) || 6);
    let activeLocation = 'all';
    let visibleCount = initialCount;

    const matchingCards = () => cards.filter((card) => (
      activeLocation === 'all' || card.dataset.reviewLocation === activeLocation
    ));

    const render = (announce = false) => {
      const matching = matchingCards();
      const visible = Math.min(visibleCount, matching.length);

      cards.forEach((card) => {
        const matches = matching.includes(card);
        const position = matches ? matching.indexOf(card) : -1;
        card.hidden = !matches || position >= visible;
      });

      if (moreButton) {
        moreButton.hidden = visible >= matching.length;
      }

      if (status) {
        status.textContent = `Showing ${visible} of ${matching.length} reviews`;
        if (announce) status.focus?.({ preventScroll: true });
      }
    };

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        activeLocation = filter.dataset.reviewFilter || 'all';
        visibleCount = initialCount;
        filters.forEach((item) => {
          const isActive = item === filter;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
        render(true);
      });
    });

    moreButton?.addEventListener('click', () => {
      visibleCount += loadCount;
      render(true);
    });

    render();
  };

  document.querySelectorAll('[data-google-reviews]').forEach(initGoogleReviews);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-google-reviews]').forEach(initGoogleReviews);
  });
})();
